export interface ISymbol {
    name: string,
    reelPosition: number,
    reelTargetPosition: number,
    reelId: number
    position: PIXI.Point,
    isRemoved: boolean
}

export interface ISymbolPosition {
    reelId: number,
    startPosition: number,
    targetPosition: number
}

export enum SimpleReelModelState {
    IDLE = "IDLE",
    START = "START",
    SPIN = "SPIN",
    STOP = "STOP",
    STOPPED = "STOPPED",
    BOUNCE = "BOUNCE",
}

export interface SimpleReelModelEventData {
    reel: number;
    state: SimpleReelModelState;
}